const HOST = window.location.host

const apiObj = {
  VUE_APP_NAME: HOST === 'c.banhuiyun.com' ? 'production' : 'development',
  VUE_APP_BASE_API:
    HOST === 'c.banhuiyun.com'
      ? 'https://api.banhuiyun.com'
      : 'http://api.bhykf.com',
  VUE_APP_UPYUN_API:
    HOST === 'c.banhuiyun.com'
      ? 'https://v0.api.upyun.com'
      : 'http://v0.api.upyun.com',
  VUE_APP_BASE_SERVE:
    HOST === 'c.banhuiyun.com'
      ? 'https://c.banhuiyun.com/'
      : 'http://c.bhykf.com/',
  VUE_APP_BASE_ASSETS:
    HOST === 'c.banhuiyun.com'
      ? 'https://assets.banhuiyun.com'
      : 'http://assets.bhykf.com',
  VUE_APP_BASE_CDN:
    HOST === 'c.banhuiyun.com'
      ? 'https://cdn.banhuiyun.com'
      : 'http://cdn.bhykf.com',
  VUE_APP_PARAMS: HOST === 'c.banhuiyun.com'
    ? {
      rmb: {
        accountid: 'b179656f398e13ab',
        projectid: 'c17988a275e22fdd'
      },
      dollar: {
        accountid: 'b179656f398e13ab',
        projectid: 'z17988a2be92f99a'
      }
    }
    : {
      rmb: {
        accountid: 'f1746935ddcfbd37',
        projectid: 'b17979512decde28'
      },
      dollar: {
        accountid: 'f1746935ddcfbd37',
        projectid: 'a17968a4f1628888'
      }
    },
  VUE_APP_ACCOUNT: HOST === 'c.banhuiyun.com' ? {
    companyid: 'j179656f398eb448',
    channelid: 'uidAdminSystem'
  } : {
    companyid: 'g1746935ddcf6a6e',
    channelid: 'uidAdminSystem'
  }
}

module.exports = apiObj
